import { useEffect, useState } from "react"

import { FieldData, mapFilters } from "@/components/_Shared/FilterWrapper"

import { useFilterStorage } from "@/hook/useFilterStorage"

import { CUSTOMER_CATEGORIES_KEY } from "@/types/ICustomerCategory"
import { FilterField, FilterFieldOperator, FilterFieldType } from "@/types/ui"


export const useCustomerCategoryFilters = () => {
  const [filters, setFilters] = useState<FilterField[]>([])

  const { getFilter } = useFilterStorage({
    key: CUSTOMER_CATEGORIES_KEY
  })

  const oldFilters: FieldData[] = getFilter()

  useEffect(() => {
    setFilters([
      ...CustomerCategoryFilters
    ])
  }, [])

  return mapFilters(filters, oldFilters)
}

const CustomerCategoryFilters: FilterField[] = [
  {
    text: "Наименование",
    name: "name",
    type: FilterFieldType.Text,
    operator: FilterFieldOperator.Contains
  }
]
